import React, { startTransition, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ComparePrice from "../ControlPanel/ComparePrice/ComparePrice.js";
import { useDispatch, useSelector } from "react-redux";
import { getManufacturerStateQuoteForNonLoggedIn, handleShowComparePriceModal } from "../../action/index";
import PriceDetail from "../ControlPanel/ComparePrice/PriceDetail.js";
import PriceDetailNonLoggedIn from "../ControlPanel/ComparePrice/PriceDetailNonLoggedIn.js";
import ComparePriceNotLoggedIn from "../ControlPanel/ComparePrice/ComparePriceNotLoggedIn.js";


const ComparePriceModal = () => {
  const dispatch = useDispatch();
  const props = useSelector((state) => state.reducer);

  const selectedManufacturer = props.selectedManufacturer;
  const selectedStatekey = `selectedState_${props.params.p_s_n}`;
  const [selectedManufactures,setSelectedmanufactures] = useState([]);
  const [showDefaultOfferonly,setDefaultOffer] = useState(false)
  // const selectedManufactures =
  //   props?.nonLoggedInpriceCompareData &&
  //   props?.nonLoggedInpriceCompareData[selectedStatekey];
  const [showPriceDetail, setShowPriceDetail] = useState(false);
  const [loading, setLoading] = useState("0");
  const [startAnimation, setStartAnimation] = useState(false);
  const [selectedManufactureDetail, setManufactureDetail] = useState(null);
  const handleStartAnimation = (val) => {
    setStartAnimation(val);
  };
  const [mainManufactureQuoteData,setMainManufactureQuoteData] = useState(null);

  useEffect(()=>{
    let tmp = props?.nonLoggedInpriceCompareData && props?.nonLoggedInpriceCompareData[selectedStatekey]?.filter(obj => obj.id != props.params.m_s_n)

    if(tmp?.length == 0 && props?.nonLoggedInpriceCompareData[selectedStatekey].length > 1){
      tmp.push(props?.nonLoggedInpriceCompareData[selectedStatekey][0])
      setDefaultOffer(true)
    }else{
      setDefaultOffer(false)
    }
    
    setSelectedmanufactures(tmp)
  },[props.params.p_s_n,props.params.m_s_n,props?.nonLoggedInpriceCompareData && props?.nonLoggedInpriceCompareData[selectedStatekey]])
  const custom = () => {
    document.getElementsByClassName("modal")[0].style.transform =
      "translate(-100%, 0)";
    document.getElementsByClassName("modal")[0].style.transition =
      "all 1.2s ease-in-out";
    setTimeout(() => {
      dispatch(handleShowComparePriceModal());
    }, 500);
  };

  useEffect(() => {
    if(props.params.m_s_n && props.const_var.loginSession && props.isShowComparePriceModal) {
      getManufacturerStateQuoteForNonLoggedIn(props.params.m_s_n).then(res => {
        const response = {
            data:res
        }
        setMainManufactureQuoteData(response.data)
       })
    }
    },[props.params.m_s_n,props.isShowComparePriceModal])
  useEffect(() => {
    setTimeout(() => {
      setShowPriceDetail(props.isShowComparePriceModal);
      setStartAnimation(true);
      selectedManufactures != undefined && selectedManufactures != null && Object.entries(selectedManufactures)?.length > 0 && setManufactureDetail(selectedManufactures[0])
    }, 1500);
  }, [props.isShowComparePriceModal]);

  useEffect(() => {
    if(window.innerWidth < 1024) {
      if(props.isShowComparePriceModal) {
        setTimeout(() => {
          dispatch(handleShowComparePriceModal());
        }, 700);
      }
    }
  }, [window.innerWidth]);

  const isMFGLoading = props.const_var?.comparisionLoadermfg1 || props.const_var?.comparisionLoadermfg2

  return (
    <div>
      <Modal
        show={props.isShowComparePriceModal}
        backdrop="static"
        keyboard={false}
        onHide={handleShowComparePriceModal}
        dialogClassName={`summary-modal compare-price-modal  ${!props.const_var.loginSession && 'non-loggedIn'}`}
        backdropClassName="ract-modal-pre-parent"
      >
        <div className="summary-price-wrapper">
          <div className="summary-wrapper">
            <div className="summary-modal-body compare-price-modal-body">
              {selectedManufactures != undefined && selectedManufactures != null  && selectedManufactures.length > 0 && !props.const_var.loginSession ? (
                <ComparePriceNotLoggedIn
                  startAnimation={startAnimation}
                  handleStartAnimation={handleStartAnimation}
                  setLoading={setLoading}
                  loading={loading}
                  setManufactureDetail={setManufactureDetail}
                  allManufacturers={selectedManufactures}
                  isShowComparePriceModal={props.isShowComparePriceModal}
                  custom={custom}
                  showDefaultOfferonly={showDefaultOfferonly}
                />
              ) : (
                <ComparePrice
                  startAnimation={startAnimation}
                  handleStartAnimation={handleStartAnimation}
                  setLoading={setLoading}
                  loading={loading}
                  mainManufactureQuoteStateData={mainManufactureQuoteData}
                  custom={custom}
                />
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ComparePriceModal;
